/**
 * 修改应用实体组件
 * zxw
 * 创建时间 2026-02-06
 */

import CNF from '../../incs/Config';
import {
    locale,
    AddRequestHeaders,
    StrToBase64Encode,
    uploadAvatarButton,
    UjoinParams,
    GetBase64,
    AliyunOSSclient,
    AliyunOSSDelete,
} from '../../incs/FunHelper';

import { useState, useEffect } from 'react';
import $ from 'jquery';
import {
    ConfigProvider,
    Modal,
    Space,
    Typography,
    Input,
    message,
    Upload,
    Image,
} from 'antd';
import ImgCrop from 'antd-img-crop';
import {
    PlusOutlined,
} from '@ant-design/icons';

const { Text, } = Typography;
const { TextArea } = Input;

const MODULENAME_URL = '/app/infos';

const AppUpdateEntity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [appName, setAppName] = useState(null); // 应用名称
    const [appDescription, setAppDescription] = useState(null); // 应用描述

    // 应用图标部分
    const [fileList, setFileList] = useState([]);             //  图片列表
    const [deleteFileList, setDeleteFileList] = useState([]); //  删除图片列表
    const [previewOpen, setPreviewOpen] = useState(false);    //  图片预览是否打开
    const [previewImage, setPreviewImage] = useState('');     //  图片预览资源

    useEffect(() => {
        setOpen(props.open);
        setAppName(props.record.app_name);
        setAppDescription(props.record.app_description);
        if (props.record.app_icon) {
            let fileList = [];
            const url = props.record.app_icon;
            fileList.push({
                uid: 1,
                url: url,
                path: props.record.app_icon,
                preview: url,
                status: 'done',
                percent: 100,
            });
            setFileList(fileList);
        }
    }, [props]);

    const cancel = () => {
        setOpen(false);
    }

    const ok = () => {
        //  参数校验
        if (appName === '') {
            messageApi.error('应用名称不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1,)}/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'app_name': appName,
                'app_description': appDescription,
                'app_icon': fileList && fileList.length > 0 ? fileList[0].url : '',
            })
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.setRefresh();
                    setLoading(false);
                }, CNF.messageDuration * 1000);
                deleteFileList && deleteFileList.length > 0 && deleteFileList.forEach(function (file) {
                    AliyunOSSDelete(file);
                });
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const preview = (file) => {
        console.log('preview', file);
        if (!file.preview) {
            if (file.originFileObj) {
                // 转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 5120000) {
            messageApi.error('上传图片超过5M，请重新上传！', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, acl = 'public-read') => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': acl
        }
        var params = {
            'acl': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    try {
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            //  路径由以下部分组成
                            let path = CNF.projectCode.toLowerCase();   // 项目代码
                            path += '/ais'; // app_icon图片文件夹
                            path += '/' + StrToBase64Encode(props.record.app_id);   // 应用id转Base64字符串
                            path += '__'; // 分隔符
                            path += Math.floor(Date.now() / 1000).toString()
                            path += '__'; // 分隔符
                            path += '32-ais-300-300.png';
                            // 获取最新的文件列表
                            let newFileList = [...fileList];
                            AliyunOSSclient(token).multipartUpload(path, file,
                                {
                                    //  请求头
                                    headers,
                                    //  获取分片上传进度、断点和返回值
                                    progress: (p) => {
                                        setFileList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length - 1] = {
                                                ...newItems[newItems.length - 1],
                                                percent: parseInt(p * 100),
                                                status: p === 1 ? 'done' : 'uploading',
                                                url: CNF.ossApi + path,
                                                path: path,
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    },
                                    //  分片数量
                                    parallel: Math.ceil(file.size / 1024 / 1024),
                                    //  设置分片大小，默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    //  上传成功
                                    if (result.res.status === 200) { }
                                }).catch((e) => {
                                    //  上传失败
                                    messageApi.error(file.name + ' 上传失败！', CNF.messageDuration);
                                    setFileList(newFileList.pop());
                                });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
        return false
    }


    return <ConfigProvider
        locale={locale}
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
        {contextHolder}
        <Modal
            title={<span style={{ color: CNF.colorBaseText }}>修改应用信息</span>}
            mask={{ blur: false }}
            width={680}
            open={open}
            onOk={ok}
            onCancel={cancel}
            okButtonProps={{ loading }}
            style={{
                top: CNF.menuHeight,
            }}
            styles={{
                container: {
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                header: {
                    paddingLeft: CNF.basePadding,
                    paddingBottom: 14,
                    borderBottom: `1px solid ${CNF.colorBaseBorderSolid}`,
                    marginBottom: 0,
                },
                footer: {
                    borderTop: `1px solid ${CNF.colorBaseBorderSolid}`,
                    marginTop: 0,
                    paddingRight: CNF.basePadding,
                    paddingTop: CNF.basePadding,
                }
            }}
        >

            {/* 内容部分 */}
            <Space orientation='vertical' size='middle' style={{ width: '100%', padding: CNF.basePadding, }}>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>应用名称<Text type='danger'>*</Text></Text>
                    <Input
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请输入应用名称'
                        count={{
                            show: true,
                            max: 25,
                        }}
                        status={appName?.length > 50 || appName === '' ? 'error' : ''}
                        value={appName}
                        onChange={(e) => setAppName(e.target.value)}
                    />
                    {
                        appName === '' ? <Text type='danger'>请输入应用名称</Text> : ''
                    }
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>应用描述</Text>
                    <TextArea
                        showCount
                        style={{ width: `calc(100% - ${CNF.basePadding * 2}px)`, color: CNF.colorBaseText }}
                        placeholder='请输入应用描述'
                        autoSize={{ minRows: 3, maxRows: 4 }}
                        maxLength={120}
                        value={appDescription}
                        onChange={(e) => setAppDescription(e.target.value)}
                    />
                </div>
                <div>
                    <Text style={{ color: CNF.colorBaseText }}>应用图像</Text>
                    <ImgCrop rotationSlider>
                        <Upload
                            name='avatar'
                            beforeUpload={beforeUpload}
                            listType='picture-card'
                            style={{ padding: 0 }}
                            icon={<PlusOutlined />}
                            customRequest={({ file }) => {
                                // 生成新的 blob URL 用于预览
                                const blobUrl = URL.createObjectURL(file);
                                // 更新 fileList 中对应文件的 thumbUrl
                                setFileList(prevList =>
                                    prevList.map(f =>
                                        f.uid === file.uid ? { ...f, thumbUrl: blobUrl, url: blobUrl } : f
                                    )
                                );
                                aliyunOSSUpload(file);
                            }}
                            fileList={fileList}
                            onPreview={preview}
                            onChange={({ fileList: newFileList }) => {
                                setFileList(newFileList);
                            }}
                            onRemove={(file) => {
                                // 移入删除文件列表
                                setDeleteFileList([...deleteFileList, file]);
                            }}
                        >
                            {fileList.length > 0 ? null : uploadAvatarButton}
                        </Upload>
                    </ImgCrop>
                    {previewImage && (
                        <Image
                            wrapperStyle={{
                                display: 'none',
                            }}
                            alt='avatar'
                            style={{
                                width: '100%',
                            }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    )}
                </div>
            </Space>
        </Modal >
    </ConfigProvider>
}

export default AppUpdateEntity